import { useCallback, useMemo } from 'react';

import { ProductWidget, VisibilityLevel } from '@vestico/model';

export interface UseProductLinkHookProps {
  product: ProductWidget | null | undefined;
  showProductLink?: boolean;
  onProductLinkClick?: (product: ProductWidget) => void;
}

export const useProductLink = ({ product, showProductLink, onProductLinkClick }: UseProductLinkHookProps) => {
  const linkToProduct = useMemo(() => {
    if (!product) {
      return false;
    }
    const { visibility } = product;
    return showProductLink && visibility < VisibilityLevel.hiddenDetection;
  }, [showProductLink, product]);

  // Add https to final url if needed
  const finalURL = useMemo(() => {
    if (!product || !linkToProduct) {
      return null;
    }
    const { url } = product;
    return url.startsWith('http') ? url : `https://${url}`;
  }, [linkToProduct, product]);

  const handleProductLinkClick = useCallback(() => {
    if (!finalURL) {
      return;
    }
    window.location.href = finalURL;
    if (onProductLinkClick && product) {
      onProductLinkClick(product);
    }
  }, [finalURL, onProductLinkClick, product]);

  return { url: finalURL, goToProduct: handleProductLinkClick };
};
